import { ddcLog } from './logger.js';
import { hasPrice } from '../integrations/initialPaymentCalc/buildCalcConfig.js';
import { PAYMENT_OBJECT_UPDATE, PAYMENT_CALC_RESPONSE_UPDATE } from '../global-constants.js';

// There's nothing to calculate with no resolvable price, so we skip the
// payments API call entirely and emit an empty PaymentObject:Update.
const NO_PRICE_PAYMENT_OBJECTS = [];

// Not awaited by the caller — pricing has no timeout and may never resolve on
// pages that never fire ws-detailed-pricing/price-update, so UDS init must
// stay off the critical path and can't block the placements that follow it.
function waitForPricingAndInit(waitForPricingUpdate, vehicle, initializeUDS) {
	(async () => {
		try {
			const pricingData = await waitForPricingUpdate;

			if (!hasPrice(vehicle, pricingData)) {
				ddcLog('Skipping UDS init: no resolvable price');
				window.caiEventBus.emit(PAYMENT_OBJECT_UPDATE, NO_PRICE_PAYMENT_OBJECTS);
			} else {
				await initializeUDS(pricingData);
			}
		} catch (error) {
			ddcLog('UDS init failed:', error);
		}
	})();
}

export function createLegacyUdsLoader(waitForPricingUpdate, vehicles, mmdId, theme) {
	return async () => {
		const { initializeUDSLegacyIntegration } = await import(
			/* webpackChunkName: 'uds-legacy' */
			'../integrations/uds.legacy.js'
			);
		return async () => {
			waitForPricingAndInit(waitForPricingUpdate, vehicles?.[0], (pricingData) => (
				initializeUDSLegacyIntegration({ pricingData, mmdId, theme })
			));
		};
	};
}

export function createModernUdsLoader(config, vehicles, mmdId, waitForPricingUpdate, theme) {
	return async () => {
		const { initializeUDSIntegration } = await import(
			/* webpackChunkName: 'uds' */
			'../integrations/uds.js'
			);
		return async () => {
			waitForPricingAndInit(waitForPricingUpdate, vehicles?.[0], (pricingData) => (
				initializeUDSIntegration({ config, vehicles, mmdId, pricingData, theme })
			));
		};
	};
}

export async function resolveUdsPromise({ udsLoader }) {
	if (udsLoader) {
		ddcLog('Loading UDS integration...');
		try {
			return await udsLoader();
		} catch (err) {
			ddcLog('UDS integration failed to load:', err);
		}
	} else {
		// Event to notify WS-track-offer-widget to hide tabs
		window.caiEventBus.emit(PAYMENT_CALC_RESPONSE_UPDATE, { paymentErrorState: true });
	}

	return () => Promise.resolve();
}
